module.exports = __webpack_public_path__ + "img/YingGong.9396203f.png";